import { LoaderCircle } from 'lucide-react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

import { WorkspaceProvider } from '../contexts/WorkspaceContext';
import { useAuth } from '../hooks/useAuth';

/**
 * Wrapper for /w/:slug/* routes. Verifies the user is a member of the workspace.
 * Workspace context flows from the URL — no JWT workspace binding needed.
 */
export function WorkspaceRoute(): React.ReactElement {
  const { slug } = useParams<{ slug: string }>();
  const { user, workspaces, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <LoaderCircle size={24} className="animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  const ws = slug ? workspaces.find((w) => w.id === slug) : undefined;
  if (!slug || !ws) {
    if (workspaces.length > 0) {
      return <Navigate to={`/w/${workspaces[0]!.id}`} replace />;
    }
    return <Navigate to="/new-workspace" replace />;
  }

  return (
    <WorkspaceProvider key={slug} slug={slug} workspace={ws}>
      <Outlet />
    </WorkspaceProvider>
  );
}
